// extracted by mini-css-extract-plugin
export default {"banner":"AboutBanner_banner__c0dIA","logo-main":"AboutBanner_logo-main__052Uf","banner-image":"AboutBanner_banner-image__js7v6","banner-video":"AboutBanner_banner-video__EnQ4k"};